<div class="tfr-page-shell py-8">
  <div class="space-y-6">
    <section class="tfr-admin-section px-5 py-5 sm:px-6">
      <p class="tfr-admin-kicker">Administración</p>
      <div class="mt-3 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div class="space-y-2">
          <h1 class="text-[28px] font-semibold leading-tight tracking-tight text-midnight-indigo">
            Facturación de la plataforma
          </h1>
          <p class="max-w-2xl text-[13px] leading-relaxed text-slate-blue">
            Datos del emisor TimeFlexRent para sus facturas de comisi&oacute;n al propietario.
            El propietario gestiona por separado cualquier factura dirigida al cliente.
          </p>
        </div>
        <div class="rounded-2xl border border-pale-gray bg-cloud-mist px-4 py-3 text-right">
          <p class="text-[10px] font-semibold uppercase tracking-[0.24em] text-steel-gray">Firestore</p>
          <p class="mt-1 text-[13px] font-medium text-midnight-indigo">/config/globalSettings.platformBilling</p>
        </div>
      </div>
      <p class="mt-4 text-[12px] text-steel-gray">
        <a routerLink="/admin/settings" class="text-action-blue hover:underline">Plantilla de contrato global</a>
        &middot;
        <a routerLink="/admin/dashboard" class="text-action-blue hover:underline">Panel admin</a>
      </p>
    </section>

    @if (loadError()) {
      <section class="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ loadError() }}
      </section>
    }

    @if (loading()) {
      <section class="tfr-admin-section p-8 text-center text-[13px] text-steel-gray">
        Cargando datos de facturación&hellip;
      </section>
    } @else {
      <section class="tfr-admin-section p-4 sm:p-6">
        <form [formGroup]="form" (ngSubmit)="save()" class="space-y-5" novalidate>
          <div>
            <p class="tfr-admin-kicker tracking-[0.26em]">Emisor</p>
            <h2 class="text-[18px] font-semibold text-midnight-indigo mt-1">Mis datos de facturación</h2>
          </div>

          <fieldset class="space-y-2">
            <legend class="tfr-field-label">Tipo de emisor</legend>
            <div class="flex flex-col gap-3 sm:flex-row">
              <label class="flex items-center gap-2 text-[13px] text-midnight-indigo">
                <input type="radio" formControlName="issuerType" value="self_employed" />
                Aut&oacute;nomo / persona f&iacute;sica
              </label>
              <label class="flex items-center gap-2 text-[13px] text-midnight-indigo">
                <input type="radio" formControlName="issuerType" value="company" />
                Sociedad / persona jur&iacute;dica
              </label>
            </div>
          </fieldset>

          @if (form.controls.issuerType.value === 'self_employed') {
            <label class="flex items-start gap-2 rounded-xl border border-pale-gray bg-cloud-mist px-3 py-3
                          text-[13px] text-midnight-indigo">
              <input type="checkbox" formControlName="withholdingEnabled" class="mt-0.5" />
              <span>
                Mi actividad est&aacute; sujeta a retenci&oacute;n IRPF
                <span class="mt-0.5 block text-[11px] text-steel-gray">
                  Conf&iacute;rmalo con tu asesor fiscal. Solo se aplicar&aacute; cuando el propietario deba retener.
                </span>
              </span>
            </label>
          }

          <div class="flex flex-col gap-1">
            <label class="tfr-field-label" for="platform-legal-name">Razón social</label>
            <input id="platform-legal-name" type="text" formControlName="legalName" class="tfr-input" />
            @if (showError('legalName')) {
              <p class="tfr-error">{{ fieldError('legalName') }}</p>
            }
          </div>

          <div class="flex flex-col gap-1">
            <label class="tfr-field-label" for="platform-tax-id">CIF / NIF</label>
            <input id="platform-tax-id" type="text" formControlName="taxId" class="tfr-input uppercase" />
            <p class="text-[11px] text-steel-gray">CIF de la sociedad o NIF si facturas como autónomo.</p>
            @if (showError('taxId')) {
              <p class="tfr-error">{{ fieldError('taxId') }}</p>
            }
          </div>

          <div class="flex flex-col gap-1">
            <label class="tfr-field-label" for="platform-address">Dirección fiscal</label>
            <input id="platform-address" type="text" formControlName="addressLine1" class="tfr-input"
                   placeholder="Calle, número, piso" />
            @if (showError('addressLine1')) {
              <p class="tfr-error">{{ fieldError('addressLine1') }}</p>
            }
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div class="flex flex-col gap-1">
              <label class="tfr-field-label" for="platform-postal">C.P.</label>
              <input id="platform-postal" type="text" formControlName="postalCode" maxlength="5" class="tfr-input" />
              @if (showError('postalCode')) {
                <p class="tfr-error">{{ fieldError('postalCode') }}</p>
              }
            </div>
            <div class="flex flex-col gap-1">
              <label class="tfr-field-label" for="platform-city">Ciudad</label>
              <input id="platform-city" type="text" formControlName="city" class="tfr-input" />
              @if (showError('city')) {
                <p class="tfr-error">{{ fieldError('city') }}</p>
              }
            </div>
            <div class="flex flex-col gap-1">
              <label class="tfr-field-label" for="platform-province">Provincia</label>
              <input id="platform-province" type="text" formControlName="province" class="tfr-input" />
              @if (showError('province')) {
                <p class="tfr-error">{{ fieldError('province') }}</p>
              }
            </div>
          </div>

          <div class="border-t border-pale-gray pt-5 space-y-4">
            <div>
              <p class="tfr-admin-kicker tracking-[0.26em]">Impuestos</p>
              <h2 class="text-[18px] font-semibold text-midnight-indigo mt-1">IVA e IRPF</h2>
              <p class="text-[12px] text-steel-gray mt-1 max-w-2xl">
                La comisi&oacute;n pactada ya incluye IVA. La retenci&oacute;n solo se aplica si TimeFlexRent
                factura como aut&oacute;nomo sujeto a retenci&oacute;n y el propietario es persona jur&iacute;dica
                o persona f&iacute;sica que act&uacute;a como empresario/profesional.
              </p>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div class="flex flex-col gap-1">
                <label class="tfr-field-label" for="platform-vat">IVA repercutido (%)</label>
                <input id="platform-vat" type="number" formControlName="vatRatePercent"
                       min="0" max="100" step="0.1" class="tfr-input" />
                @if (showError('vatRatePercent')) {
                  <p class="tfr-error">{{ fieldError('vatRatePercent') }}</p>
                }
              </div>
              <div class="flex flex-col gap-1">
                <label class="tfr-field-label" for="platform-irpf">Retención IRPF por defecto (%)</label>
                <input id="platform-irpf" type="number" formControlName="irpfWithholdingPercent"
                       min="0" max="47" step="0.1" class="tfr-input" />
                @if (form.controls.issuerType.value === 'company') {
                  <p class="text-[11px] text-steel-gray">No se aplicar&aacute; mientras el emisor sea una sociedad.</p>
                } @else if (!form.controls.withholdingEnabled.value) {
                  <p class="text-[11px] text-steel-gray">No se aplicar&aacute; mientras la retenci&oacute;n est&eacute; desactivada.</p>
                }
                @if (showError('irpfWithholdingPercent')) {
                  <p class="tfr-error">{{ fieldError('irpfWithholdingPercent') }}</p>
                }
              </div>
            </div>

            <div class="flex flex-wrap gap-2">
              @for (preset of irpfPresets; track preset.value) {
                <button type="button"
                        (click)="setIrpfPreset(preset.value)"
                        class="rounded-lg border border-pale-gray px-3 py-1.5 text-[12px] font-semibold text-slate-blue hover:bg-cloud-mist">
                  {{ preset.label }}
                </button>
              }
            </div>
          </div>

          @if (saveError()) {
            <p class="text-[12px] text-red-600">{{ saveError() }}</p>
          } @else if (saveSuccess()) {
            <p class="text-[12px] text-emerald-600">Datos de facturación de la plataforma guardados.</p>
          }

          <div class="flex justify-end pt-2">
            <button type="submit"
                    [disabled]="saving() || form.pristine"
                    class="inline-flex items-center justify-center rounded-2xl px-5 py-3 text-[13px] font-semibold text-snow-white bg-action-blue transition-all hover:brightness-110 disabled:opacity-50">
              @if (saving()) { Guardando&hellip; } @else { Guardar datos de facturación }
            </button>
          </div>
        </form>
      </section>
    }
  </div>
</div>
